import { ADMIN_MOCK_ROUTES } from './admin/admin.mock';
import { BASILISK_MOCK_ROUTES } from './basilisk/basilisk.mock';
import { CADASTRO_MOCK_ROUTES } from './cadastro/cadastro.mock';
import { CONTESTACAO_MOCK_ROUTES } from './contestacao/contestacao.mock';
import { CONTEXT_MOCK_ROUTES } from './context/context.mock';
import { DASHBOARD_MOCK_ROUTES } from './dashboards/dashboards.mock';
import { JOBS_MOCK_ROUTES } from './jobs/jobs.mock';
import { KNOWLEDGE_BASE_MOCK_ROUTES } from './knowledge-base/knowledge-base.mock';
import { MockRoute } from './mock-api';
import { SESSION_MOCK_ROUTES } from './session/session.mock';

/**
 * Todas as rotas simuladas. A primeira que casar (método + caminho) responde, então:
 * - rotas específicas de `/jobs/:id/...` (revisão da Contestação, laudo do Basilisk) vêm antes das de jobs;
 * - dentro de cada domínio, rotas fixas (`/jobs/overview`) vêm antes das com parâmetro (`/jobs/:id`).
 */
export const MOCK_ROUTES: MockRoute[] = [
	...SESSION_MOCK_ROUTES,
	...BASILISK_MOCK_ROUTES,
	...CONTESTACAO_MOCK_ROUTES,
	...JOBS_MOCK_ROUTES,
	...DASHBOARD_MOCK_ROUTES,
	...CADASTRO_MOCK_ROUTES,
	...KNOWLEDGE_BASE_MOCK_ROUTES,
	...CONTEXT_MOCK_ROUTES,
	...ADMIN_MOCK_ROUTES,
];
